import { render, staticRenderFns } from "./SessionDetailsRemote.vue?vue&type=template&id=83e27fea&"
import script from "./SessionDetailsRemote.vue?vue&type=script&lang=ts&"
export * from "./SessionDetailsRemote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports